import { useEffect, useRef } from 'react';

export default function Feedback({ content }) {
  const surveyRef = useRef(null);

  useEffect(() => {
    const surveyHost = surveyRef.current;
    if (!surveyHost) {
      return undefined;
    }

    surveyHost.innerHTML = '';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = content.surveySrc;
    script.async = false;
    script.dataset.nextEngineEmbed = 'feedback-survey';
    surveyHost.appendChild(script);

    return () => {
      surveyHost.innerHTML = '';
    };
  }, [content.surveySrc]);

  return (
    <section className="section section-feedback" id="feedback">
      <div className="section-inner feedback-layout">
        <div className="feedback-heading">
          <h2>{content.title}</h2>
        </div>

        <div className="feedback-frame">
          <div className="feedback-survey-shell">
            <div
              className="feedback-survey-host"
              data-testid="feedback-survey"
              data-survey-src={content.surveySrc}
              ref={surveyRef}
            >
              <p>{content.loading}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}